export const IS_PRODUCTION = process.env.NEXT_PUBLIC_ENV === 'prod'
export const ENV: 'local' | 'stg' | 'prod' = process.env.NEXT_PUBLIC_ENV as
  | 'local'
  | 'stg'
  | 'prod'
